export default __webpack_public_path__ + "static/media/alertDetails.b3959983.png";